// Service để gọi Groq API (Llama 3.1)
const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY || 'YOUR_GROQ_API_KEY_HERE';
const GROQ_API_URL = 'https://api.groq.com/openai/v1/chat/completions';

class GroqService {
  constructor() {
    this.conversationHistory = []; // Lưu lịch sử chat
    this.apiKey = GROQ_API_KEY;
  }

  /**
   * Gửi tin nhắn đến Groq API và nhận phản hồi
   * @param {string} userMessage - Tin nhắn của người dùng
   * @param {boolean} stream - Có muốn stream response không (mặc định false)
   * @returns {Promise<string>} - Phản hồi từ AI
   */
  async sendMessage(userMessage, stream = false) {
    if (!this.apiKey || this.apiKey === 'YOUR_GROQ_API_KEY_HERE') {
      throw new Error('Vui lòng cấu hình GROQ_API_KEY trong file .env');
    }

    // Thêm tin nhắn người dùng vào lịch sử
    this.conversationHistory.push({
      role: 'user',
      content: userMessage,
    });

    try {
      const response = await fetch(GROQ_API_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.apiKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile', // Model mới thay thế llama-3.1-70b-versatile (đã ngừng hỗ trợ)
          messages: [
            // System message để định hướng chatbot
            {
              role: 'system',
              content: 'Bạn là Bobo, trợ lý AI thông minh của Smartify - hệ thống nhà thông minh. Bạn giúp người dùng:\n' +
                '- Điều khiển thiết bị nhà thông minh\n' +
                '- Thiết lập tự động hóa\n' +
                '- Quản lý năng lượng\n' +
                '- Trả lời câu hỏi về Smartify\n' +
                'Hãy trả lời ngắn gọn, thân thiện và hữu ích. Trả lời bằng tiếng Việt.'
            },
            ...this.conversationHistory.slice(-10), // Chỉ giữ 10 tin nhắn gần nhất
          ],
          temperature: 0.7,
          max_tokens: 1024,
          stream: stream,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error?.message || `HTTP error! status: ${response.status}`);
      }

      if (stream) {
        // Xử lý stream response (nếu cần)
        return this.handleStreamResponse(response);
      } else {
        const data = await response.json();
        const assistantMessage = data.choices[0]?.message?.content || 'Không nhận được phản hồi';
        
        // Thêm phản hồi vào lịch sử
        this.conversationHistory.push({
          role: 'assistant',
          content: assistantMessage,
        });

        return assistantMessage;
      }
    } catch (error) {
      console.error('Groq API Error:', error);
      throw error;
    }
  }

  /**
   * Xử lý stream response (cho typing effect)
   * @param {Response} response - Response từ fetch
   * @returns {AsyncGenerator<string>} - Generator trả về từng chunk
   */
  async *handleStreamResponse(response) {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ') && line !== 'data: [DONE]') {
            try {
              const data = JSON.parse(line.substring(6));
              const content = data.choices[0]?.delta?.content;
              if (content) {
                yield content;
              }
            } catch (e) {
              // Bỏ qua lỗi parse
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }
  }

  /**
   * Xóa lịch sử chat
   */
  clearHistory() {
    this.conversationHistory = [];
  }

  /**
   * Lấy lịch sử chat
   */
  getHistory() {
    return this.conversationHistory;
  }
}

// Export singleton instance
export default new GroqService();

